// src/components/Section.jsx
import React from "react";
import { BRAND } from "../config/brandConfig";

function Section({ eyebrow, title, kicker, children }) {
  return (
    <section style={{ marginBottom: "4rem" }}>
      {eyebrow && (
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: "0.08em",
            color: BRAND.accent,
            textTransform: "uppercase",
            marginBottom: "0.25rem",
          }}
        >
          {eyebrow}
        </div>
      )}
      {title && (
        <h2
          style={{
            fontSize: 26,
            fontWeight: 700,
            margin: 0,
            marginBottom: kicker ? "0.5rem" : "1rem",
            color: "#0f172a",
          }}
        >
          {title}
        </h2>
      )}
      {kicker && (
        <p
          style={{
            fontSize: 14,
            color: "#475569",
            marginTop: 0,
            marginBottom: "1.25rem",
            maxWidth: 640,
          }}
        >
          {kicker}
        </p>
      )}
      {children}
    </section>
  );
}

export default Section;
